import Select from "react-select";
import styled from "styled-components";

export const AGSelect = styled(Select)`
	min-height: 34px;
	width: 100%;
	font-size: 0.875rem;
	cursor: pointer;
	@media (max-width: 768px) {
		padding-left: 0;
	}
	@media (max-width: 640px) {
		.css-1nmdiq5-menu .css-1n6sfyn-MenuList span {
			font-size: 12px;
			overflow-wrap: break-word;
		}
	}
`;

export const AGOptionTag = styled.span`
	background: #e8e8e8;
	border-radius: 15px;
	font-size: 0.6875rem;
	padding: 2px 10px;
	font-weight: bold;
	color: rgb(99, 115, 129);
`;
